import { ACTION_DIALOG_CLOSE } from 'events';
import { component } from 'picoapp';

// Utils
import { sendSelectEvent } from 'utils/variant';

export default component(async (node, ctx) => {
  const selectors = node.querySelectorAll('[data-variant]');

  selectors.forEach((item) => {
    item.addEventListener('click', () => {
      sendSelectEvent(item.dataset.variant, item.dataset.handle, item.dataset.title);

      ctx.emit(ACTION_DIALOG_CLOSE);
    });
  });
});
